import React from 'react'
import {Provider} from 'react-redux'
import configureStore, {history} from './redux/configureStore'
import Navigation from './nav'
import ErrorView from './components/ErrorView'
import {ThemeProvider} from '@material-ui/core'
import mainTheme from './theme'

const store = configureStore()

function App() {
  document.title = 'React-PT Body Engineering Administration'
  return (
    <Provider store={store}>
      <ThemeProvider theme={mainTheme}>
        <ErrorView />
        <Navigation history={history} />
      </ThemeProvider>
    </Provider>
  )
}

export default App
